<p-dialog
  [(visible)]="visible"
  (onHide)="fechar()"
  [modal]="true"
  [style]="{ width: 'min(72rem, 96vw)', height: '90vh' }"
  [draggable]="false"
  [resizable]="false"
  styleClass="doc-preview-dialog"
  [dismissableMask]="true"
>
  <ng-template #header>
    <div class="preview-custom-header">
      <div class="doc-header-info">
        <span class="doc-type-badge">{{ rotuloTipoAtual }}</span>
        <h3 class="doc-file-title" [title]="docAtual?.nomeFicheiro">
          {{ docAtual?.nomeFicheiro || 'Documento' }}
        </h3>
        <span class="doc-file-size" *ngIf="docAtual?.tamanho">
          ({{ formatarTamanho(docAtual?.tamanho) }})
        </span>

        @if (docAtual?.estadoValidacaoEnum; as stEnum) {
          @let st = getEstadoBadge(stEnum);
          <span class="status-badge status-badge--{{ st?.severity }}">
            {{ st?.label }}
          </span>
        }
      </div>

      <div class="nav-controls">
        <button
          type="button"
          class="btn-nav"
          [disabled]="!temAnterior"
          (click)="anterior()"
          pTooltip="Documento anterior (Seta esquerda)"
        >
          <i class="pi pi-chevron-left"></i>
        </button>
        <span class="nav-counter" *ngIf="totalDocs > 0">
          {{ indiceAtual + 1 }} de {{ totalDocs }}
        </span>
        <button
          type="button"
          class="btn-nav"
          [disabled]="!temSeguinte"
          (click)="seguinte()"
          pTooltip="Documento seguinte (Seta direita)"
        >
          <i class="pi pi-chevron-right"></i>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Rejection Banner if rejected -->
  <div class="rejection-alert-banner" *ngIf="docAtual?.motivoRejeicao">
    <i class="pi pi-exclamation-triangle"></i>
    <div class="banner-text">
      <strong>Documento Reprovado:</strong>
      <span>{{ docAtual?.motivoRejeicao }}</span>
    </div>
  </div>

  <!-- Viewer Canvas -->
  <div class="preview-canvas-container">
    @if (erroAoCarregar) {
      <div class="preview-error-state">
        <i class="pi pi-exclamation-circle"></i>
        <h4>Ficheiro Indisponível para Pré-visualização</h4>
        <p>Não foi possível carregar a pré-visualização deste anexo.</p>
        <button type="button" class="btn-download-action" (click)="descarregar()">
          <i class="pi pi-download"></i> Tentar Descarregar Ficheiro
        </button>
      </div>
    } @else if (isPdf) {
      <div class="pdf-viewer-box">
        <iframe
          *ngIf="blobUrlSafe"
          [src]="blobUrlSafe"
          (load)="aoCarregarFicheiro()"
          (error)="aoFalharCarregamento()"
          class="pdf-iframe"
          title="Pré-visualização do PDF"
        ></iframe>
      </div>
    } @else if (isImagem) {
      <div class="image-viewer-box">
        <div class="zoom-toolbar">
          <button type="button" class="btn-zoom" (click)="zoomOut()" pTooltip="Reduzir zoom">
            <i class="pi pi-search-minus"></i>
          </button>
          <span class="zoom-level">{{ (nivelZoom * 100).toFixed(0) }}%</span>
          <button type="button" class="btn-zoom" (click)="zoomIn()" pTooltip="Aumentar zoom">
            <i class="pi pi-search-plus"></i>
          </button>
          <button type="button" class="btn-zoom" (click)="resetZoom()" pTooltip="Ajustar ao ecrã">
            <i class="pi pi-refresh"></i>
          </button>
        </div>
        <div class="image-viewport">
          <img
            *ngIf="blobUrlSafe"
            [src]="blobUrlSafe"
            (load)="aoCarregarFicheiro()"
            (error)="aoFalharCarregamento()"
            [style.transform]="'scale(' + nivelZoom + ')'"
            class="preview-img"
            [alt]="docAtual?.nomeFicheiro"
          />
        </div>
      </div>
    } @else {
      <div class="preview-generic-file">
        <div class="generic-file-card">
          <i class="pi pi-file generic-file-icon"></i>
          <h4 class="generic-file-name">{{ docAtual?.nomeFicheiro }}</h4>
          <span class="generic-file-type">Formato não suportado para pré-visualização embutida</span>
          <button type="button" class="btn-download-action" (click)="descarregar()">
            <i class="pi pi-download"></i> Descarregar Ficheiro
          </button>
        </div>
      </div>
    }

    @if (carregandoBlob && !erroAoCarregar) {
      <div class="preview-loading-state" role="status">
        <i class="pi pi-spin pi-spinner"></i>
        <p>A carregar pré-visualização segura...</p>
      </div>
    }
  </div>

  <ng-template #footer>
    <div class="preview-modal-footer">
      <div class="footer-left">
        <button type="button" class="btn-outline-action" (click)="descarregar()">
          <i class="pi pi-download"></i>
          <span>Descarregar Ficheiro</span>
        </button>
      </div>

      <div class="footer-right" *ngIf="permitirAcoes">
        <button
          type="button"
          class="btn-reprovar-doc"
          [disabled]="processandoValidacao"
          (click)="onReprovar()"
        >
          <i class="pi pi-times-circle"></i>
          <span>Reprovar</span>
        </button>
        <button
          type="button"
          class="btn-aprovar-doc"
          [disabled]="processandoValidacao"
          (click)="onAprovar()"
        >
          <i class="pi pi-check-circle"></i>
          <span>Aprovar</span>
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
